import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSun: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSun"><Path d="M11.9999 3.5V1.5M20.5 12H22.5M18.0104 18.0104L19.4246 19.4246M18.0104 5.98959L19.4246 4.57538M11.9999 22.5V20.5M1.5 12H3.5M4.57504 4.57538L5.98926 5.98959M4.57504 19.4246L5.98926 18.0104M15.889 8.11091C18.0369 10.2588 18.0369 13.7412 15.889 15.8891C13.7411 18.037 10.2587 18.037 8.11085 15.8891C5.96297 13.7412 5.96297 10.2588 8.11085 8.11091C10.2587 5.96303 13.7411 5.96303 15.889 8.11091Z" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSun;
